import type { Component } from 'vue'

export enum MENU_SECTION {
  granting,
  dafManagement,
  appContent,
  hifo,
  admin,
  growth,
  training,
  assets,
  contracts,
  events,
  other,
}

export interface MenuItem {
  name: string
  to: string
  sectionType: MENU_SECTION
}

export interface SidebarSection {
  name: string
  sectionType: MENU_SECTION
  items: MenuItem[]
  /** Section header icon; omit for a blank placeholder until a component exists. */
  icon?: Component
}
